// @ts-nocheck

import {KTSVG} from '_metronic/helpers'
import {FC, useCallback, useEffect, useState, createElement, useRef} from 'react'
import {Modal} from 'react-bootstrap'
import find from 'lodash/find'
import {Spinner} from '_core/components/Loader/Loader'

type Props = {
  shippingLabel: any
  show: boolean
  onClose: () => void
}

const SelectPrinters: FC<Props> = ({show, onClose, shippingLabel}) => {
  const [devices, setDevices] = useState([])
  const [isFetching, setIsFetching] = useState(true)
  const [isPrinting, setIsPrinting] = useState(false)
  const [selectedPrinterId, setSelectedPrinterId] = useState<any>({})
  const [errorMessage, setErrorMessage] = useState('')
  const isLoaded = useRef(false)

  const getPrinters = useCallback(() => {
    BrowserPrint.getLocalDevices(
      (deviceList) => {
        setDevices(deviceList)
        setIsFetching(false)
      },
      (error) => {
        console.error(error)
        setErrorMessage('Error getting printer devices')
        setIsFetching(false)
      },
      'printer'
    )
  }, [])

  const getConfig = useCallback(() => {
    if (BrowserPrint) {
      BrowserPrint.getApplicationConfiguration(
        (config) => {
          console.log(config)
          getPrinters()
        },
        (error) => {
          console.error(error)
          setErrorMessage(
            'Zebra Browser Print is not installed or not running! Download the App from https://www.zebra.com/us/en/software/printer-software/browser-print.html'
          )
          setIsFetching(false)
        }
      )
    } else {
      setErrorMessage('Error getting printer devices')
    }
  }, [])

  useEffect(() => {
    if (!isLoaded.current) {
      getConfig()
    }
  }, [])

  const handleChange = (event) => {
    setSelectedPrinterId(event.target.value)
  }

  const handlePrint = async () => {
    const label = atob(shippingLabel.encodedLabel || shippingLabel.graphicImage)
    const selectedDevice = find(devices, {uid: selectedPrinterId})
    if (selectedDevice) {
      setIsPrinting(true)
      if (await isReadyToPrint(selectedDevice)) {
        selectedDevice.send(label, handleCompleted, handleError)
      }
    }
  }

  const zplJSPrintManager = () => {
    if (jspmWSStatus()) {
      const label = atob(shippingLabel.encodedLabel || shippingLabel.graphicImage)
      const cpj = new JSPM.ClientPrintJob()
      cpj.printerCommands = label
      cpj.sendToClient()
      onClose()
    }
  }

  const handleCompleted = (success) => {
    onClose()
    setIsPrinting(false)
  }

  const handleError = (errorMessage) => {
    console.error(errorMessage)
    setIsPrinting(false)
  }

  const isReadyToPrint = async (selectedDevice) => {
    const zebraPrinter = new Zebra.Printer(selectedDevice)
    try {
      await zebraPrinter.isPrinterReady()
      return true
    } catch (error) {
      console.error(error)
      getStatus(zebraPrinter)
    }

    return false
  }

  const getStatus = (zebraPrinter) => {
    zebraPrinter.getStatus(
      (status) => {
        setErrorMessage(status.getMessage())
        setIsPrinting(false)
      },
      (error) => {
        console.error(error)
        setErrorMessage(error)
        setIsPrinting(false)
      }
    )
  }

  const jspmWSStatus = () => {
    if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Open) return true
    else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Closed) {
      setErrorMessage(
        'JSPrintManager (JSPM) is not installed or not running! Download JSPM Client App from https://neodynamic.com/downloads/jspm'
      )
      return false
    } else if (JSPM.JSPrintManager.websocket_status == JSPM.WSStatus.Blocked) {
      setErrorMessage('JSPM has blocked this website!')
      return false
    }
  }

  const print = () => {
    const label = atob(shippingLabel.encodedLabel || shippingLabel.graphicImage)
    var printWindow = window.open('', '', 'popup')
    if (printWindow) {
      printWindow.document.open('text/plain', '_top', 'popup')
      printWindow.document.write(label)
      printWindow.document.close()
      printWindow.focus()
      printWindow.print()
      printWindow.close()

      onClose()
    }
  }

  return (
    <Modal
      show={show}
      keyboard={false}
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='h-auto'
      onHide={onClose}
    >
      <div className='modal-header d-flex'>
        <h5 className='modal-title'>Select Printer</h5>
        <div className='btn btn-sm btn-icon btn-active-color-primary' onClick={onClose}>
          <KTSVG
            className='svg-icon-2 border rounded-1 border-primary svg-icon-primary'
            path='/media/icons/duotune/arrows/arr061.svg'
          />
        </div>
      </div>

      {isFetching && <Spinner />}
      <Modal.Body>
        <select
          title='Shipping label'
          className='form-select'
          value={selectedPrinterId}
          onChange={handleChange}
        >
          <option>Select</option>
          {devices.map((device) => (
            <option key={device.uid} value={device.uid}>
              {device.name}
            </option>
          ))}
        </select>

        {errorMessage && <p className='text-danger mt-2'>{renderHTML(errorMessage)}</p>}
      </Modal.Body>

      <Modal.Footer>
        <button type='button' onClick={onClose} className='btn btn-sm btn-secondary'>
          Close
        </button>

        <button
          type='button'
          disabled={isPrinting}
          onClick={handlePrint}
          className='btn btn-sm btn-primary'
        >
          Print Zebra
        </button>

        <button
          type='button'
          disabled={isPrinting}
          onClick={zplJSPrintManager}
          className='btn btn-sm btn-primary'
        >
          Print JSPM
        </button>

        <button
          type='button'
          disabled={isPrinting}
          onClick={print}
          className='btn btn-sm btn-primary'
        >
          Print
        </button>
      </Modal.Footer>
    </Modal>
  )
}

export default SelectPrinters

const renderHTML = (rawHTML: any) =>
  createElement('span', {dangerouslySetInnerHTML: {__html: rawHTML}})
